import api from '@/sui/api/api'

import axios from 'axios'

export default {
  getCancelTokenSource () {
    return axios.CancelToken.source()
  },

  info (finess, token) {
    return api.post('/establishment/get', { f: finess })
  }
}
